import axios from 'axios';

/**
 * Whether the brand published a legal document in the engine (Legales in the admin). The public
 * link (`utils/legal.js`) cannot tell: it redirects to the client's page or renders a 404 page. The
 * integrations endpoint answers 404 `not-found` until the brand publishes the document. Asked once
 * per page load; a failed request is not kept, so the next screen asks again.
 */
const published = {};

export const isLegalPublished = type => {
  if (!published[type]) {
    published[type] = axios
      .get(`${process.env.REACT_APP_API_THIRDPARTY_URL}/legal/${type}`, {
        headers: { 'x-reachout-secret': process.env.REACT_APP_SECRET },
      })
      .then(res => Boolean(res?.data?.document))
      .catch(() => {
        delete published[type];
        return false;
      });
  }
  return published[type];
};
